<div>
  <main class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    <div class="flex items-baseline justify-between pb-6 pt-3">
      <h1 class="text-3xl font-bold tracking-tight text-gray-700">All Calculators</h1>
    </div>
  </main>
</div>
